// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmationBooking_container__xppJe","confirmation":"ConfirmationBooking_confirmation__WcAXq"};